import { AdministrativeAgents } from './AdministrativeAgents';

export default AdministrativeAgents;
